// Upon load, inject code to the rewards page based on the content loaded
let RewardInit = () => {
  let rewardTimeout = undefined;

  const init = () => {
    let rewardEl = document.querySelector(".loyalty-root #vip-tiers-section .lp99_tier-card");

    if (!rewardEl) {
      rewardTimeout = setTimeout(init, 1000);
      return;
    }

    // Inject
    let styleEl = document.createElement("style");
    styleEl.innerHTML = `
      div#root.loyalty-root * {
        font-family: "Neue Haas" !important;
      }

      #vip-tiers-section > div > div > div.lp99_flex {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
      }

      #vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(1) {
        justify-self: right;
      }

      #vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(2) {
        justify-self: center;
      }

      #vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(3) {
        justify-self: left;
      }

      .lp99_tier-card .sk-r-img {
        margin-bottom: 42px;
        margin-top: 10px;
        padding: 0;
      }

      #vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(1) .sk-r-img {
        width: 65px;
      }

      #vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(2) .sk-r-img {
        width: 145px;
      }

      #vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(3) .sk-r-img {
        width: 165px;
      }

      .loyalty-root .lp99_bg-gray-100 {
        background-color: transparent !important;
      }

      strong, b {
        font-weight: normal !important;
      }

      #vip-tiers-section > .lp99_vip-wrapper > .lp99_lg-width {
        padding-bottom: calc(64px + 34px);
      }

      .main-content {
        background-color: #fdfdfd;
      }

      main section:last-child {
        padding-bottom: 0 !important;
      }
    `;

    let pinkEl = document.querySelector("#vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(1)");
    let blueEl = document.querySelector("#vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(2)");
    let goldEl = document.querySelector("#vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(3)");

    let pinkDesc = document.querySelector("#vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(1) .lp99_space-y-1");
    let blueDesc = document.querySelector("#vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(2) .lp99_space-y-1");
    let goldDesc = document.querySelector("#vip-tiers-section div.lp99_flex div.lp99_tier-card:nth-child(3) .lp99_space-y-1");

    let pinkImg = document.createElement("img");
    let blueImg = document.createElement("img");
    let goldImg = document.createElement("img");

    pinkImg.classList.add("sk-r-img");
    blueImg.classList.add("sk-r-img");
    goldImg.classList.add("sk-r-img");

    pinkImg.setAttribute("src", "https://cdn.shopify.com/s/files/1/0271/7351/9412/files/Pink_Tier_Gift.png?v=1746622846");
    blueImg.setAttribute("src", "https://cdn.shopify.com/s/files/1/0271/7351/9412/files/Blue_Tier_Gift.png?v=1746622846");
    goldImg.setAttribute("src", "https://cdn.shopify.com/s/files/1/0271/7351/9412/files/Gold_Tier_Gift.png?v=1746622847");

    pinkEl.insertBefore(pinkImg, pinkDesc);
    blueEl.insertBefore(blueImg, blueDesc);
    goldEl.insertBefore(goldImg, goldDesc);

    document.body.appendChild(styleEl);

    // Move section above the reward types section
    let vipTiersSec = document.querySelector("#vip-tiers-section");
    let waysToEarnSec = document.querySelector("#ways-to-earn-section");
    let secContainer = document.querySelector(".loyalty-root .lp99_bg-gray-100");

    vipTiersSec.remove();
    secContainer.insertBefore(vipTiersSec, waysToEarnSec);
  }

  rewardTimeout = setTimeout(init, 1000);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    RewardInit = RewardInit();
  });
} else {
  RewardInit = RewardInit();
}
